// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__8f8ph","content":"Auth_content__7l6mk"};